/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AgentTransferDestinationLinkDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageTransferDestinationSummaryDTO } from '../models';
// @ts-ignore
import type { TransferDestinationCreateDTO } from '../models';
// @ts-ignore
import type { TransferDestinationResponseDTO } from '../models';
// @ts-ignore
import type { TransferDestinationSearchResponseDTO } from '../models';
// @ts-ignore
import type { TransferDestinationSummaryDTO } from '../models';
// @ts-ignore
import type { TransferDestinationUpdateDTO } from '../models';
/**
 * TransferDestinationsApi - axios parameter creator
 * @export
 */
export const TransferDestinationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new transfer destination. Requires \'transfer:write\' permission.
         * @summary Create Transfer Destination
         * @param {TransferDestinationCreateDTO} transferDestinationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransferDestinationApiV1TransferDestinationsPost: async (transferDestinationCreateDTO: TransferDestinationCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferDestinationCreateDTO' is not null or undefined
            assertParamExists('createTransferDestinationApiV1TransferDestinationsPost', 'transferDestinationCreateDTO', transferDestinationCreateDTO)
            const localVarPath = `/api/v1/transfer-destinations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferDestinationCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new transfer destination. Requires \'transfer:write\' permission.
         * @summary Create Transfer Destination
         * @param {TransferDestinationCreateDTO} transferDestinationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransferDestinationApiV1TransferDestinationsPost_1: async (transferDestinationCreateDTO: TransferDestinationCreateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transferDestinationCreateDTO' is not null or undefined
            assertParamExists('createTransferDestinationApiV1TransferDestinationsPost_1', 'transferDestinationCreateDTO', transferDestinationCreateDTO)
            const localVarPath = `/api/v1/transfer-destinations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferDestinationCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a transfer destination. Requires \'transfer:write\' permission.
         * @summary Delete Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete: async (destinationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete', 'destinationId', destinationId)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a transfer destination. Requires \'transfer:write\' permission.
         * @summary Delete Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2: async (destinationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2', 'destinationId', destinationId)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all transfer destinations available to an agent. Requires \'transfer:view\' permission.  Returns both organization-wide and agent-specific destinations.
         * @summary Get Agent Transfer Destinations
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet', 'agentId', agentId)
            const localVarPath = `/api/v1/transfer-destinations/agents/{agent_id}/destinations`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all transfer destinations available to an agent. Requires \'transfer:view\' permission.  Returns both organization-wide and agent-specific destinations.
         * @summary Get Agent Transfer Destinations
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3', 'agentId', agentId)
            const localVarPath = `/api/v1/transfer-destinations/agents/{agent_id}/destinations`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get agents linked to a transfer destination. Requires \'transfer:view\' permission.  Returns the full destination object including linked agents.
         * @summary Get Destination Agents
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet: async (destinationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet', 'destinationId', destinationId)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}/agents`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get agents linked to a transfer destination. Requires \'transfer:view\' permission.  Returns the full destination object including linked agents.
         * @summary Get Destination Agents
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4: async (destinationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4', 'destinationId', destinationId)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}/agents`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific transfer destination by ID. Requires \'transfer:view\' permission.
         * @summary Get Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferDestinationApiV1TransferDestinationsDestinationIdGet: async (destinationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('getTransferDestinationApiV1TransferDestinationsDestinationIdGet', 'destinationId', destinationId)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific transfer destination by ID. Requires \'transfer:view\' permission.
         * @summary Get Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5: async (destinationId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5', 'destinationId', destinationId)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all transfer destinations for the organization. Requires \'transfer:view\' permission.
         * @summary List Transfer Destinations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransferDestinationsApiV1TransferDestinationsGet: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/transfer-destinations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all transfer destinations for the organization. Requires \'transfer:view\' permission.
         * @summary List Transfer Destinations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransferDestinationsApiV1TransferDestinationsGet_6: async (limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/transfer-destinations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full-text search transfer destinations with real total count
         * @summary Search Transfer Destinations
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [scope] Additionally filter by scope (combined with search as AND)
         * @param {string | null} [destinationType] Additionally filter by destination type (phone or sip_uri)
         * @param {boolean | null} [isActive] Additionally filter by active state
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransferDestinationsApiV1TransferDestinationsSearchGet: async (q: string, limit?: number, offset?: number, scope?: string | null, destinationType?: string | null, isActive?: boolean | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchTransferDestinationsApiV1TransferDestinationsSearchGet', 'q', q)
            const localVarPath = `/api/v1/transfer-destinations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (destinationType !== undefined) {
                localVarQueryParameter['destination_type'] = destinationType;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full-text search transfer destinations with real total count
         * @summary Search Transfer Destinations
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [scope] Additionally filter by scope (combined with search as AND)
         * @param {string | null} [destinationType] Additionally filter by destination type (phone or sip_uri)
         * @param {boolean | null} [isActive] Additionally filter by active state
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransferDestinationsApiV1TransferDestinationsSearchGet_7: async (q: string, limit?: number, offset?: number, scope?: string | null, destinationType?: string | null, isActive?: boolean | null, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchTransferDestinationsApiV1TransferDestinationsSearchGet_7', 'q', q)
            const localVarPath = `/api/v1/transfer-destinations/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            if (destinationType !== undefined) {
                localVarQueryParameter['destination_type'] = destinationType;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update agents linked to a transfer destination. Requires \'transfer:write\' permission.  This replaces all existing agent links.
         * @summary Update Destination Agents
         * @param {string} destinationId 
         * @param {AgentTransferDestinationLinkDTO} agentTransferDestinationLinkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut: async (destinationId: string, agentTransferDestinationLinkDTO: AgentTransferDestinationLinkDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut', 'destinationId', destinationId)
            // verify required parameter 'agentTransferDestinationLinkDTO' is not null or undefined
            assertParamExists('updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut', 'agentTransferDestinationLinkDTO', agentTransferDestinationLinkDTO)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}/agents`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentTransferDestinationLinkDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update agents linked to a transfer destination. Requires \'transfer:write\' permission.  This replaces all existing agent links.
         * @summary Update Destination Agents
         * @param {string} destinationId 
         * @param {AgentTransferDestinationLinkDTO} agentTransferDestinationLinkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8: async (destinationId: string, agentTransferDestinationLinkDTO: AgentTransferDestinationLinkDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8', 'destinationId', destinationId)
            // verify required parameter 'agentTransferDestinationLinkDTO' is not null or undefined
            assertParamExists('updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8', 'agentTransferDestinationLinkDTO', agentTransferDestinationLinkDTO)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}/agents`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentTransferDestinationLinkDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a transfer destination. Requires \'transfer:write\' permission.
         * @summary Update Transfer Destination
         * @param {string} destinationId 
         * @param {TransferDestinationUpdateDTO} transferDestinationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch: async (destinationId: string, transferDestinationUpdateDTO: TransferDestinationUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch', 'destinationId', destinationId)
            // verify required parameter 'transferDestinationUpdateDTO' is not null or undefined
            assertParamExists('updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch', 'transferDestinationUpdateDTO', transferDestinationUpdateDTO)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferDestinationUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a transfer destination. Requires \'transfer:write\' permission.
         * @summary Update Transfer Destination
         * @param {string} destinationId 
         * @param {TransferDestinationUpdateDTO} transferDestinationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9: async (destinationId: string, transferDestinationUpdateDTO: TransferDestinationUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'destinationId' is not null or undefined
            assertParamExists('updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9', 'destinationId', destinationId)
            // verify required parameter 'transferDestinationUpdateDTO' is not null or undefined
            assertParamExists('updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9', 'transferDestinationUpdateDTO', transferDestinationUpdateDTO)
            const localVarPath = `/api/v1/transfer-destinations/{destination_id}`
                .replace(`{${"destination_id"}}`, encodeURIComponent(String(destinationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferDestinationUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransferDestinationsApi - functional programming interface
 * @export
 */
export const TransferDestinationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransferDestinationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new transfer destination. Requires \'transfer:write\' permission.
         * @summary Create Transfer Destination
         * @param {TransferDestinationCreateDTO} transferDestinationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransferDestinationApiV1TransferDestinationsPost(transferDestinationCreateDTO: TransferDestinationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransferDestinationApiV1TransferDestinationsPost(transferDestinationCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.createTransferDestinationApiV1TransferDestinationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new transfer destination. Requires \'transfer:write\' permission.
         * @summary Create Transfer Destination
         * @param {TransferDestinationCreateDTO} transferDestinationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTransferDestinationApiV1TransferDestinationsPost_1(transferDestinationCreateDTO: TransferDestinationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTransferDestinationApiV1TransferDestinationsPost_1(transferDestinationCreateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.createTransferDestinationApiV1TransferDestinationsPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a transfer destination. Requires \'transfer:write\' permission.
         * @summary Delete Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete(destinationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a transfer destination. Requires \'transfer:write\' permission.
         * @summary Delete Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2(destinationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all transfer destinations available to an agent. Requires \'transfer:view\' permission.  Returns both organization-wide and agent-specific destinations.
         * @summary Get Agent Transfer Destinations
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferDestinationSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all transfer destinations available to an agent. Requires \'transfer:view\' permission.  Returns both organization-wide and agent-specific destinations.
         * @summary Get Agent Transfer Destinations
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferDestinationSummaryDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get agents linked to a transfer destination. Requires \'transfer:view\' permission.  Returns the full destination object including linked agents.
         * @summary Get Destination Agents
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet(destinationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get agents linked to a transfer destination. Requires \'transfer:view\' permission.  Returns the full destination object including linked agents.
         * @summary Get Destination Agents
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4(destinationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific transfer destination by ID. Requires \'transfer:view\' permission.
         * @summary Get Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransferDestinationApiV1TransferDestinationsDestinationIdGet(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransferDestinationApiV1TransferDestinationsDestinationIdGet(destinationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.getTransferDestinationApiV1TransferDestinationsDestinationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific transfer destination by ID. Requires \'transfer:view\' permission.
         * @summary Get Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5(destinationId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all transfer destinations for the organization. Requires \'transfer:view\' permission.
         * @summary List Transfer Destinations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTransferDestinationsApiV1TransferDestinationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransferDestinationSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTransferDestinationsApiV1TransferDestinationsGet(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.listTransferDestinationsApiV1TransferDestinationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all transfer destinations for the organization. Requires \'transfer:view\' permission.
         * @summary List Transfer Destinations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTransferDestinationsApiV1TransferDestinationsGet_6(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransferDestinationSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTransferDestinationsApiV1TransferDestinationsGet_6(limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.listTransferDestinationsApiV1TransferDestinationsGet_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Full-text search transfer destinations with real total count
         * @summary Search Transfer Destinations
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [scope] Additionally filter by scope (combined with search as AND)
         * @param {string | null} [destinationType] Additionally filter by destination type (phone or sip_uri)
         * @param {boolean | null} [isActive] Additionally filter by active state
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTransferDestinationsApiV1TransferDestinationsSearchGet(q: string, limit?: number, offset?: number, scope?: string | null, destinationType?: string | null, isActive?: boolean | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationSearchResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTransferDestinationsApiV1TransferDestinationsSearchGet(q, limit, offset, scope, destinationType, isActive, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.searchTransferDestinationsApiV1TransferDestinationsSearchGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Full-text search transfer destinations with real total count
         * @summary Search Transfer Destinations
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [scope] Additionally filter by scope (combined with search as AND)
         * @param {string | null} [destinationType] Additionally filter by destination type (phone or sip_uri)
         * @param {boolean | null} [isActive] Additionally filter by active state
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTransferDestinationsApiV1TransferDestinationsSearchGet_7(q: string, limit?: number, offset?: number, scope?: string | null, destinationType?: string | null, isActive?: boolean | null, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationSearchResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTransferDestinationsApiV1TransferDestinationsSearchGet_7(q, limit, offset, scope, destinationType, isActive, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.searchTransferDestinationsApiV1TransferDestinationsSearchGet_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update agents linked to a transfer destination. Requires \'transfer:write\' permission.  This replaces all existing agent links.
         * @summary Update Destination Agents
         * @param {string} destinationId 
         * @param {AgentTransferDestinationLinkDTO} agentTransferDestinationLinkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut(destinationId: string, agentTransferDestinationLinkDTO: AgentTransferDestinationLinkDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut(destinationId, agentTransferDestinationLinkDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update agents linked to a transfer destination. Requires \'transfer:write\' permission.  This replaces all existing agent links.
         * @summary Update Destination Agents
         * @param {string} destinationId 
         * @param {AgentTransferDestinationLinkDTO} agentTransferDestinationLinkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8(destinationId: string, agentTransferDestinationLinkDTO: AgentTransferDestinationLinkDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8(destinationId, agentTransferDestinationLinkDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a transfer destination. Requires \'transfer:write\' permission.
         * @summary Update Transfer Destination
         * @param {string} destinationId 
         * @param {TransferDestinationUpdateDTO} transferDestinationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch(destinationId: string, transferDestinationUpdateDTO: TransferDestinationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch(destinationId, transferDestinationUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a transfer destination. Requires \'transfer:write\' permission.
         * @summary Update Transfer Destination
         * @param {string} destinationId 
         * @param {TransferDestinationUpdateDTO} transferDestinationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9(destinationId: string, transferDestinationUpdateDTO: TransferDestinationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferDestinationResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9(destinationId, transferDestinationUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransferDestinationsApi.updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransferDestinationsApi - factory interface
 * @export
 */
export const TransferDestinationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransferDestinationsApiFp(configuration)
    return {
        /**
         * Create a new transfer destination. Requires \'transfer:write\' permission.
         * @summary Create Transfer Destination
         * @param {TransferDestinationCreateDTO} transferDestinationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransferDestinationApiV1TransferDestinationsPost(transferDestinationCreateDTO: TransferDestinationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.createTransferDestinationApiV1TransferDestinationsPost(transferDestinationCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new transfer destination. Requires \'transfer:write\' permission.
         * @summary Create Transfer Destination
         * @param {TransferDestinationCreateDTO} transferDestinationCreateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTransferDestinationApiV1TransferDestinationsPost_1(transferDestinationCreateDTO: TransferDestinationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.createTransferDestinationApiV1TransferDestinationsPost_1(transferDestinationCreateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a transfer destination. Requires \'transfer:write\' permission.
         * @summary Delete Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete(destinationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a transfer destination. Requires \'transfer:write\' permission.
         * @summary Delete Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2(destinationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all transfer destinations available to an agent. Requires \'transfer:view\' permission.  Returns both organization-wide and agent-specific destinations.
         * @summary Get Agent Transfer Destinations
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferDestinationSummaryDTO>> {
            return localVarFp.getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all transfer destinations available to an agent. Requires \'transfer:view\' permission.  Returns both organization-wide and agent-specific destinations.
         * @summary Get Agent Transfer Destinations
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferDestinationSummaryDTO>> {
            return localVarFp.getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get agents linked to a transfer destination. Requires \'transfer:view\' permission.  Returns the full destination object including linked agents.
         * @summary Get Destination Agents
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet(destinationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get agents linked to a transfer destination. Requires \'transfer:view\' permission.  Returns the full destination object including linked agents.
         * @summary Get Destination Agents
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4(destinationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific transfer destination by ID. Requires \'transfer:view\' permission.
         * @summary Get Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferDestinationApiV1TransferDestinationsDestinationIdGet(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.getTransferDestinationApiV1TransferDestinationsDestinationIdGet(destinationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific transfer destination by ID. Requires \'transfer:view\' permission.
         * @summary Get Transfer Destination
         * @param {string} destinationId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5(destinationId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all transfer destinations for the organization. Requires \'transfer:view\' permission.
         * @summary List Transfer Destinations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransferDestinationsApiV1TransferDestinationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageTransferDestinationSummaryDTO> {
            return localVarFp.listTransferDestinationsApiV1TransferDestinationsGet(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List all transfer destinations for the organization. Requires \'transfer:view\' permission.
         * @summary List Transfer Destinations
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransferDestinationsApiV1TransferDestinationsGet_6(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageTransferDestinationSummaryDTO> {
            return localVarFp.listTransferDestinationsApiV1TransferDestinationsGet_6(limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Full-text search transfer destinations with real total count
         * @summary Search Transfer Destinations
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [scope] Additionally filter by scope (combined with search as AND)
         * @param {string | null} [destinationType] Additionally filter by destination type (phone or sip_uri)
         * @param {boolean | null} [isActive] Additionally filter by active state
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransferDestinationsApiV1TransferDestinationsSearchGet(q: string, limit?: number, offset?: number, scope?: string | null, destinationType?: string | null, isActive?: boolean | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationSearchResponseDTO> {
            return localVarFp.searchTransferDestinationsApiV1TransferDestinationsSearchGet(q, limit, offset, scope, destinationType, isActive, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Full-text search transfer destinations with real total count
         * @summary Search Transfer Destinations
         * @param {string} q Full-text search query
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string | null} [scope] Additionally filter by scope (combined with search as AND)
         * @param {string | null} [destinationType] Additionally filter by destination type (phone or sip_uri)
         * @param {boolean | null} [isActive] Additionally filter by active state
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransferDestinationsApiV1TransferDestinationsSearchGet_7(q: string, limit?: number, offset?: number, scope?: string | null, destinationType?: string | null, isActive?: boolean | null, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationSearchResponseDTO> {
            return localVarFp.searchTransferDestinationsApiV1TransferDestinationsSearchGet_7(q, limit, offset, scope, destinationType, isActive, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update agents linked to a transfer destination. Requires \'transfer:write\' permission.  This replaces all existing agent links.
         * @summary Update Destination Agents
         * @param {string} destinationId 
         * @param {AgentTransferDestinationLinkDTO} agentTransferDestinationLinkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut(destinationId: string, agentTransferDestinationLinkDTO: AgentTransferDestinationLinkDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut(destinationId, agentTransferDestinationLinkDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update agents linked to a transfer destination. Requires \'transfer:write\' permission.  This replaces all existing agent links.
         * @summary Update Destination Agents
         * @param {string} destinationId 
         * @param {AgentTransferDestinationLinkDTO} agentTransferDestinationLinkDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8(destinationId: string, agentTransferDestinationLinkDTO: AgentTransferDestinationLinkDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8(destinationId, agentTransferDestinationLinkDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a transfer destination. Requires \'transfer:write\' permission.
         * @summary Update Transfer Destination
         * @param {string} destinationId 
         * @param {TransferDestinationUpdateDTO} transferDestinationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch(destinationId: string, transferDestinationUpdateDTO: TransferDestinationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch(destinationId, transferDestinationUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a transfer destination. Requires \'transfer:write\' permission.
         * @summary Update Transfer Destination
         * @param {string} destinationId 
         * @param {TransferDestinationUpdateDTO} transferDestinationUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9(destinationId: string, transferDestinationUpdateDTO: TransferDestinationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<TransferDestinationResponseDTO> {
            return localVarFp.updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9(destinationId, transferDestinationUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransferDestinationsApi - object-oriented interface
 * @export
 * @class TransferDestinationsApi
 * @extends {BaseAPI}
 */
export class TransferDestinationsApi extends BaseAPI {
    /**
     * Create a new transfer destination. Requires \'transfer:write\' permission.
     * @summary Create Transfer Destination
     * @param {TransferDestinationCreateDTO} transferDestinationCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public createTransferDestinationApiV1TransferDestinationsPost(transferDestinationCreateDTO: TransferDestinationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).createTransferDestinationApiV1TransferDestinationsPost(transferDestinationCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new transfer destination. Requires \'transfer:write\' permission.
     * @summary Create Transfer Destination
     * @param {TransferDestinationCreateDTO} transferDestinationCreateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public createTransferDestinationApiV1TransferDestinationsPost_1(transferDestinationCreateDTO: TransferDestinationCreateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).createTransferDestinationApiV1TransferDestinationsPost_1(transferDestinationCreateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a transfer destination. Requires \'transfer:write\' permission.
     * @summary Delete Transfer Destination
     * @param {string} destinationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete(destinationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a transfer destination. Requires \'transfer:write\' permission.
     * @summary Delete Transfer Destination
     * @param {string} destinationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).deleteTransferDestinationApiV1TransferDestinationsDestinationIdDelete_2(destinationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all transfer destinations available to an agent. Requires \'transfer:view\' permission.  Returns both organization-wide and agent-specific destinations.
     * @summary Get Agent Transfer Destinations
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all transfer destinations available to an agent. Requires \'transfer:view\' permission.  Returns both organization-wide and agent-specific destinations.
     * @summary Get Agent Transfer Destinations
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).getAgentTransferDestinationsApiV1TransferDestinationsAgentsAgentIdDestinationsGet_3(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get agents linked to a transfer destination. Requires \'transfer:view\' permission.  Returns the full destination object including linked agents.
     * @summary Get Destination Agents
     * @param {string} destinationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet(destinationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get agents linked to a transfer destination. Requires \'transfer:view\' permission.  Returns the full destination object including linked agents.
     * @summary Get Destination Agents
     * @param {string} destinationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).getDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsGet_4(destinationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific transfer destination by ID. Requires \'transfer:view\' permission.
     * @summary Get Transfer Destination
     * @param {string} destinationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public getTransferDestinationApiV1TransferDestinationsDestinationIdGet(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).getTransferDestinationApiV1TransferDestinationsDestinationIdGet(destinationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific transfer destination by ID. Requires \'transfer:view\' permission.
     * @summary Get Transfer Destination
     * @param {string} destinationId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5(destinationId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).getTransferDestinationApiV1TransferDestinationsDestinationIdGet_5(destinationId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all transfer destinations for the organization. Requires \'transfer:view\' permission.
     * @summary List Transfer Destinations
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public listTransferDestinationsApiV1TransferDestinationsGet(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).listTransferDestinationsApiV1TransferDestinationsGet(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all transfer destinations for the organization. Requires \'transfer:view\' permission.
     * @summary List Transfer Destinations
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public listTransferDestinationsApiV1TransferDestinationsGet_6(limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).listTransferDestinationsApiV1TransferDestinationsGet_6(limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full-text search transfer destinations with real total count
     * @summary Search Transfer Destinations
     * @param {string} q Full-text search query
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string | null} [scope] Additionally filter by scope (combined with search as AND)
     * @param {string | null} [destinationType] Additionally filter by destination type (phone or sip_uri)
     * @param {boolean | null} [isActive] Additionally filter by active state
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public searchTransferDestinationsApiV1TransferDestinationsSearchGet(q: string, limit?: number, offset?: number, scope?: string | null, destinationType?: string | null, isActive?: boolean | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).searchTransferDestinationsApiV1TransferDestinationsSearchGet(q, limit, offset, scope, destinationType, isActive, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full-text search transfer destinations with real total count
     * @summary Search Transfer Destinations
     * @param {string} q Full-text search query
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string | null} [scope] Additionally filter by scope (combined with search as AND)
     * @param {string | null} [destinationType] Additionally filter by destination type (phone or sip_uri)
     * @param {boolean | null} [isActive] Additionally filter by active state
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public searchTransferDestinationsApiV1TransferDestinationsSearchGet_7(q: string, limit?: number, offset?: number, scope?: string | null, destinationType?: string | null, isActive?: boolean | null, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).searchTransferDestinationsApiV1TransferDestinationsSearchGet_7(q, limit, offset, scope, destinationType, isActive, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update agents linked to a transfer destination. Requires \'transfer:write\' permission.  This replaces all existing agent links.
     * @summary Update Destination Agents
     * @param {string} destinationId 
     * @param {AgentTransferDestinationLinkDTO} agentTransferDestinationLinkDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut(destinationId: string, agentTransferDestinationLinkDTO: AgentTransferDestinationLinkDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut(destinationId, agentTransferDestinationLinkDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update agents linked to a transfer destination. Requires \'transfer:write\' permission.  This replaces all existing agent links.
     * @summary Update Destination Agents
     * @param {string} destinationId 
     * @param {AgentTransferDestinationLinkDTO} agentTransferDestinationLinkDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8(destinationId: string, agentTransferDestinationLinkDTO: AgentTransferDestinationLinkDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).updateDestinationAgentsApiV1TransferDestinationsDestinationIdAgentsPut_8(destinationId, agentTransferDestinationLinkDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a transfer destination. Requires \'transfer:write\' permission.
     * @summary Update Transfer Destination
     * @param {string} destinationId 
     * @param {TransferDestinationUpdateDTO} transferDestinationUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch(destinationId: string, transferDestinationUpdateDTO: TransferDestinationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch(destinationId, transferDestinationUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a transfer destination. Requires \'transfer:write\' permission.
     * @summary Update Transfer Destination
     * @param {string} destinationId 
     * @param {TransferDestinationUpdateDTO} transferDestinationUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransferDestinationsApi
     */
    public updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9(destinationId: string, transferDestinationUpdateDTO: TransferDestinationUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return TransferDestinationsApiFp(this.configuration).updateTransferDestinationApiV1TransferDestinationsDestinationIdPatch_9(destinationId, transferDestinationUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

